import React, { Component } from 'react';
import NetworkIcon from '../NetworkIcon';
import linkedinIcon from '../../images/icons/linkedin-icon-white.svg'
import twitterIcon from '../../images/icons/twitter-icon-white.svg'
import githubIcon from '../../images/icons/github-icon-white.svg'
import photoProfil from '../../images/photo-profil.jpg'

class Home extends Component {
  render() {
    return (
    <div className="App" id={this.props.id}>
      <header className="App-header">
        <div className="photo-profil" style={{backgroundImage:`url(${photoProfil})`}} />
        
        <div className="App-title">
          <h1>FLORIAN MATHIEU</h1>
          <div className="description"> Game developer based in Strasbourg | France </div>
          <div className='network-list'>
            <NetworkIcon icon={linkedinIcon} link="https://www.linkedin.com/in/florian-mathieu-87aa41202/"/>
            <NetworkIcon icon={twitterIcon} link="https://twitter.com/Just_APenguin"/>
            <NetworkIcon icon={githubIcon} link="https://github.com/Florian-Math"/>
          </div>
          
        </div>
      </header>
    </div>
    );
  }
}

export default Home;